// removed by extract-text-webpack-plugin
module.exports = {"block":"_2tsa3Tm","fakeOutsideBlock":"xGHs8oT"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.css
// module chunks = client.sitechrome